import { combineReducers } from 'redux';
import { mobeesMiddlewares, mobeesReducer, MobeesState } from '@domain/partnerships/partners/mobees/mobees.state';
import { traktoMiddleware } from './partners/trakto/trakto.middleware';
import { traktoReducer, TraktoState } from './partners/trakto/trakto.state';

export interface State {
    partnerships: PartnershipsState;
}

export interface PartnershipsState {
    trakto: TraktoState;
    mobees: MobeesState;
}

export const partnershipsReducer = combineReducers({
    trakto: traktoReducer,
    mobees: mobeesReducer,
});

export const partnershipsMiddlewares = [
    ...mobeesMiddlewares,
    traktoMiddleware,
];
